import React, { useState } from 'react';
import styled from 'styled-components';
import { Banner } from '../../components';
import {
  Switch,
  Route,
  useRouteMatch,
  useParams,
  Redirect,
} from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';
import Context from '../../context';
import VisiMisi from './VisiMisi';
import StrukturOrganisasi from './StrukturOrganisasi';
import SejarahPerusahaan from './SejarahPerusahaan';
import { Penghargaan } from './Penghargaan';

const StyledBody = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 40px;
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

const StyledContent = styled.div`
  width: 100%;
  padding-top: 16px;
  @media screen and (max-width: 500px) {
    padding-top: 32px;
  }
`;

const TentangKamiSub = ({ data, isId }: any) => {
  const { tentangKamiId }: any = useParams();

  if (tentangKamiId === 'sejarah-perusahaan') {
    return <SejarahPerusahaan isId={isId} />;
  }

  if (tentangKamiId === 'visi-misi') {
    return <VisiMisi isId={isId} />;
  }

  if (tentangKamiId === 'struktur-organisasi') {
    return <StrukturOrganisasi isId={isId} />;
  }

  if (tentangKamiId === 'penghargaan') {
    return <Penghargaan isId={isId} />;
  }

  return <>Null</>;
};

const TentangKami = () => {
  const { path } = useRouteMatch();
  const context = React.useContext(Context);
  const currentLang = context.getLang();
  const isId = currentLang === 'ID';
  const [ttgKamiState, setTtgKamiState] = React.useState([]);
  const [loadingState, setLoadingState] = useState(true);

  const getData = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/content?type=1`
      );
      const resJson = await res.json();
      setTtgKamiState(resJson.data.rows);
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Banner title={isId ? 'Tentang Kami' : 'About Us'} />
      <StyledBody>
        <StyledContent>
          {loadingState ? (
            <div
              style={{
                width: '100%',
                padding: '0 16px',
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '4rem',
              }}
            >
              <div style={{ width: '100%', maxWidth: 1280 }}>
                <Skeleton
                  variant='rect'
                  height={42}
                  style={{ marginBottom: 16 }}
                />
                <Skeleton variant='rect' height={200} />
              </div>
            </div>
          ) : (
            <Switch>
              <Route exact path={path}>
                <Redirect to={`${path}/profile`} />
              </Route>
              <Route path={`${path}/:tentangKamiId`}>
                <TentangKamiSub isId={isId} data={ttgKamiState} />
              </Route>
            </Switch>
          )}
        </StyledContent>
      </StyledBody>
    </>
  );
};

export default TentangKami;
